export abstract class Base {

    private basePath: string;
    private jwtToken: string;

    constructor(basePath : string, jwtToken: string) {
        this.basePath = basePath;
        this.jwtToken = jwtToken;
    }

    async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
        const url = this.basePath + endpoint
        const headers = {
            'Content-type': 'application/json',
            "Authorization": `Bearer ${this.jwtToken}`,
        }

        const config = {
            ...options,
            headers,
        }

        let response = await fetch(url, config)
        if (response.ok) {
            return await response.json()
        }
        throw new Error(response.statusText)

    }
    
}